// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Edit: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M3.375,6.375 L3,9 L5.625,8.625 L10.2351565,4.01484346 L7.98515654,1.76484346 L3.375,6.375 Z M12,2.25 L9.75,0 L8.51484346,1.23515654 L10.7648435,3.48515654 L12,2.25 Z M0.75,1.5 L0,1.5 L0,2.25 L0,11.25 L0,12 L0.75,12 L9.75,12 L10.5,12 L10.5,11.25 L10.5,7.5 L10.5,6.75 L9,6.75 L9,7.5 L9,10.5 L1.5,10.5 L1.5,3 L4.5,3 L5.25,3 L5.25,1.5 L4.5,1.5 L0.75,1.5 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(Edit);
